import React from 'react';
import Script from 'next/script';
import isServer from '@/src/utils/isServer';
import { logError } from '@/src/utils/sentry';
import { initialize as initializeTracker } from '@/external-libs/tracker';
import { setPerseusTrackingCookies } from '@/external-libs/perseus';

const WebScripts = ({ trackerConfig }) => (
  <Script
    id="web_libraries_start"
    onError={(error) => logError('[SCRIPT_WEBVIEW]', error)}
  >
    {(async () => {
      if (!isServer()) {
        await initTracker(trackerConfig);
      }
    })()}
  </Script>
);

/**
 * Init the tracker lib for WebView
 * @param {object} config
 */
async function initTracker(config) {
  try {
    initializeTracker(config);
    setPerseusTrackingCookies();
  } catch (error) {
    logError('[TRACKER][INIT]', error);
  }
}

export default WebScripts;
